import {autoinject} from 'aurelia-framework';
import {Router} from 'aurelia-router';
import {EventAggregator, Subscription} from 'aurelia-event-aggregator';
import {AnalyticsService} from "./AnalyticsService";

@autoinject
export class AutoAnalyticsTracker {
    private subscription: Subscription | null = null;
    private isInitialized: boolean = false;

    constructor(
        private router: Router,
        private analyticsService: AnalyticsService,
        private eventAggregator: EventAggregator,
    ) {
    }

    public initialize(): void {
        if (this.isInitialized) {
            return;
        }

        this.trackCurrentPage();

        this.subscription = this.eventAggregator.subscribe('router:navigation:success', (event: any) => {
            setTimeout(() => {
                this.trackCurrentPage();
            }, 75);
        });

        this.isInitialized = true;
    }

    public dispose(): void {
        if (this.subscription) {
            this.subscription.dispose();
            this.subscription = null;
        }
        this.isInitialized = false;
    }

    private trackCurrentPage(): void {
        const instruction = this.router.currentInstruction;
        if (!instruction) {
            return;
        }

        const fragment = instruction.fragment;
        const config = instruction.config;
/*        const title = (config && config.title)
          || (config && config.name)
          || document.title;*/


        this.analyticsService.trackPageView(fragment, null);
    }
}
